import { render } from "./BookingDaysAdd.vue?vue&type=template&id=28db613e&scoped=true"
import script from "./BookingDaysAdd.vue?vue&type=script&lang=js"
export * from "./BookingDaysAdd.vue?vue&type=script&lang=js"

import "./BookingDaysAdd.vue?vue&type=style&index=0&id=28db613e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28db613e"]])

export default __exports__